import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { AUTH_ACTIONS } from 'src/containers/auth-container/actions/AuthActions';
import { CaseDefaultProps } from 'src/containers/case-container/CasePropTypes';
import { EXCEL_CASE_ACTIONS } from '../actions/ExcelActions';

const initialState = () => ({
    search: {
        data: [],
        count: 0,
    },

});

export default (state = initialState(), action) => {
    switch (action.type) {
    // SEARCH
        case EXCEL_CASE_ACTIONS.EXCEL_CASE_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case EXCEL_CASE_ACTIONS.EXCEL_CASE_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case EXCEL_CASE_ACTIONS.EXCEL_CASE_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }
        default:
            return state;
    }
};
